import PropTypes from 'prop-types'
import { Fragment, useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'components/Link'
import MsjBrowser from 'components/MsjBrowser'
import { removeDomainFromLink } from 'utils'

import { StyledButtonHalf, StyledHalfContainer, StyledContainerItem, StyledAsButton } from './styles'

const MultiButtonHalf = ({ allParts, currentIndex, style }) => {
  const [open, setOpen] = useState(false)
  const [link, setLink] = useState()
  const router = useRouter()

  const isBtnHalf = (part) => part && part.type === 'Button-Half'
  let loopTestNext = true

  if (!isBtnHalf(allParts[currentIndex]) || isBtnHalf(allParts[currentIndex - 1])) {
    return null
  }

  const currentBtnParts = allParts.filter((part, i) => {
    if (i < currentIndex || !loopTestNext) return false
    if (i === currentIndex) return true
    if (isBtnHalf(part)) return true
    loopTestNext = false
    return false
  })

  const getStyle = (name, part) => {
    if (part && part.style && part.style[name]) {
      return part.style[name]
    }
    if (style && style[name]) {
      return style[name]
    }
    return null
  }

  const handleOnClick = (part) => {
    if (part.msjBrowser) {
      setOpen(!open)
      setLink(part.link)
    }
  }

  return (
    <>
      <StyledHalfContainer>
        {currentBtnParts.map((part, i) => (
          <Fragment key={i}>
            <StyledContainerItem $columns={getStyle('nbrPerCol', part)}>
              {part.return ? (
                <>
                  <StyledAsButton
                    $borderWidth={getStyle('borderWidth', part) || '3'}
                    $borderRadius={getStyle('borderRadius', part) || '50'}
                    data-ga="link button-round image"
                    id="back button"
                    style={part.url && part.url.length > 0 && { backgroundImage: `url("${part.url}")` }}
                    onClick={() => history.back()}
                  >
                    <span style={{ display: 'none' }}>{part.text}</span>
                  </StyledAsButton>

                  <span id="back link" data-ga="link button-round image" onClick={() => history.back()}>
                    {part.text}
                  </span>
                </>
              ) : (
                <>
                  {part.link && part.link.length > 0 ? (
                    <>
                      <StyledButtonHalf
                        as={part.msjBrowser ? 'button' : ''}
                        href={part.msjBrowser ? '' : removeDomainFromLink(part.link, router.query.appId, router.asPath)}
                        $borderWidth={getStyle('borderWidth', part) || '3'}
                        $borderRadius={getStyle('borderRadius', part) || '50'}
                        onClick={() => handleOnClick(part)}
                        id="action with picture button"
                        data-ga="link button-round image"
                        style={part.url && part.url.length > 0 && { backgroundImage: `url("${part.url}")` }}
                        target={part.target}
                      >
                        <span style={{ display: 'none' }}>{part.text}</span>
                      </StyledButtonHalf>

                      <Link 
                        id="action with picture link" 
                        dataGa="link button-round image" 
                        href={part.msjBrowser ? '' : part.link}
                        onClick={(e) => {
                          if (part.msjBrowser) {
                            e.preventDefault()
                            handleOnClick(part)
                          }
                        }}
                      >
                        <span>{part.text}</span>
                      </Link>
                    </>
                  ) : (
                    <>
                      <StyledAsButton
                        $borderWidth={getStyle('borderWidth', part) || '3'}
                        $borderRadius={getStyle('borderRadius', part) || '50'}
                        id="action with picture button"
                        data-ga="link button-round image"
                        style={
                          part.url && part.url.length > 0
                            ? {
                                backgroundImage: `url("${part.url}")`,
                                pointerEvents: 'none',
                              }
                            : {
                                pointerEvents: 'none',
                              }
                        }
                        target={part.target}
                      >
                        <span style={{ display: 'none' }}>{part.text}</span>
                      </StyledAsButton>

                      <span>{part.text}</span>
                    </>
                  )}
                </>
              )}
            </StyledContainerItem>
          </Fragment>
        ))}
      </StyledHalfContainer>
      <MsjBrowser isOpen={open} onClose={() => setOpen(false)} src={link} />
    </>
  )
}

MultiButtonHalf.propTypes = {
  allParts: PropTypes.array,
  currentIndex: PropTypes.any,
  style: PropTypes.object,
}

export default MultiButtonHalf
